import type { ChainFamily } from 'src/blockchain';
import type { UseTxProgress } from './useTxProgress';

import { useEffect } from 'react';

import { useWallet } from 'src/blockchain';

/**
 * Clears a "no wallet is connected" refusal the moment a wallet of the deal's family is (app#315).
 *
 * The panel shows that refusal with `Connect Wallet` under it; once the person has connected —
 * through the window, or an extension — the sentence would otherwise sit next to a button that now
 * shows their address, until the next tap on the action. Only that refusal is cleared: a wallet
 * connecting says nothing about a signature that was refused or a transaction that failed.
 */
export const useClearWhenWalletConnects = (
  tx: Pick<UseTxProgress, 'needsWallet' | 'reset'>,
  family: ChainFamily | undefined
): void => {
  const { isConnected } = useWallet(family);
  const { needsWallet, reset } = tx;

  useEffect(() => {
    if (needsWallet && isConnected) {
      reset();
    }
  }, [needsWallet, isConnected, reset]);
};
